import React, { createContext, useContext, useEffect, useState } from 'react';
import { messaging } from '../../firebaseConfig';
import { onMessage, MessagePayload } from 'firebase/messaging';
import { toast } from 'react-toastify';

type NotificationContextType = {
  notifications: MessagePayload[];
  latest: MessagePayload | null;
};

const NotificationContext = createContext<NotificationContextType>({
  notifications: [],
  latest: null,
});

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [notifications, setNotifications] = useState<MessagePayload[]>([]);
  const [latest, setLatest] = useState<MessagePayload | null>(null);

  useEffect(() => {
    onMessage(messaging, (payload: MessagePayload) => {
      console.log('📨 Foreground message received:', payload);
      setNotifications((prev) => [...prev, payload]);
      setLatest(payload); // Latest one for temporary display

      if (payload.notification) {
        toast.info(
          `${payload.notification.title}: ${payload.notification.body}`
        );
      }
    });

    return () => {
      // Optionally unsubscribe
    };
  }, []);

  return (
    <NotificationContext.Provider value={{ notifications, latest }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);
